import React, {useState, useEffect} from "react";

import {useStateValue} from "./state";
import {getStreams, getShardIterator, getShardRecords} from "./data";

export const Streams = () => {
    const [{connection}, ] = useStateValue();
    const [{operation}, ] = useStateValue();
    const [{metadata}, ] = useStateValue();
    const [, dispatch ] = useStateValue();

    const t = metadata.Table || null;

    const [streams, setStreams] = useState([]);
    // const [si, setSI] = useState([]);

    const action = operation.action;

    useEffect( () => {

        const fetchData = async () => {

            const data = await getStreams(connection, operation);
            //const data = await getStreams(connection, operation);

            if(data) {

                setStreams([]);
                setStreams([data]);

                dispatch({type: 'appendLog', newMsg: 'describeStream()'});

            }
            else {
                setStreams([]);
            }
        };

        if(action && action === 'streams') {
            dispatch({type: 'appendLog', newMsg: 'listStreams()'});

            if(t && t.StreamSpecification && t.StreamSpecification.StreamEnabled) {
                fetchData();


            }
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[operation]);


    if(action && action === 'streams') {

        if(streams && streams[0]) {

            const stream = streams[0];

            return (<>


                        <b>StreamArn : </b>
                        <span className='streamArn'>
                            {stream.StreamArn}
                            {/*{stream.StreamArn.split(':')[5]}*/}
                        </span>
                        <br/>
                        <b>StreamViewType : </b>
                        {stream.StreamViewType}

                        <br/><br/>

                        <div className='shardsScroll' >

                            <RenderShards Shards={stream.Shards} />
                            <RenderShard />
                        </div>

                </>);


        } else {

            return(<p>This table does not have streams enabled.</p>);

        }
    } else {
        return (<></>);
    }


};
const ResetShardListButton = () => {
    const [{operation},] = useStateValue();
    const [, dispatch] = useStateValue();

    let buttonClass = 'btnDefault';

    const shardListOperation = {"type": "setOperation", "operation":
            {action: "streams", target: operation.target, shardId: null}
    };


    return(<button type="button"
                   onClick={() => dispatch(shardListOperation)}
                   className={buttonClass}
            >back to shard list</button>);

};


const RenderShards =  (props) => {

    const [{operation},] = useStateValue();
    const [, dispatch] = useStateValue();
    let as = 'activeShard';

    const initialShardList = (
        <table className="dataTable">
            <thead>
            <tr>
                <td><b>Parent Shard ID / Shard ID</b></td>
                <td><b>SequenceNumberRange</b></td>
            </tr>
            </thead>

            <tbody>

            {
                props.Shards.map((item, index) => {

                    const shardClickHandler = async () => {

                        const op = {action: "streams", target: operation.target, shardId: item.ShardId};

                        dispatch({"type": "setOperation", "operation": op});
                    };

                    return (<tr key={index} className={index % 2 === 1 ? "stripe1" : "stripe2"}>

                        <td className={item.SequenceNumberRange.EndingSequenceNumber ? null : as}>
                            {item.ParentShardId}<br/>

                            <button className='partitionButton' onClick={shardClickHandler}>
                                {item.ShardId}</button>

                        </td>

                        <td className={item.SequenceNumberRange.EndingSequenceNumber ? null : as}>
                            {item.SequenceNumberRange.StartingSequenceNumber}<br/>
                            {item.SequenceNumberRange.EndingSequenceNumber}
                            <br/>
                        </td>
                        <td>
                            {null}
                        </td>
                    </tr>)
                })
            }


            </tbody>

        </table>);


    if(!operation.shardId && !operation.sharditerator) {
        return initialShardList;

    } else {
        return null;
    }

};

const RenderShard = () => {
    const [{connection},] = useStateValue();
    const [{operation},] = useStateValue();
    const [{metadata},] = useStateValue();

    const [si, setSI] = useState([]);

    let cn = 'shardsScroll';

    const shardParams = {
        ShardId: operation.shardId,
        ShardIteratorType: "TRIM_HORIZON",     // "LATEST", // "TRIM_HORIZON"
        StreamArn: metadata.Table.LatestStreamArn
    };

    useEffect( () => {

        async function fetchData() {

            const data = await getShardIterator(connection, shardParams);

            setSI(data);
        }

        if (operation.sharditerator) {
            setSI(operation.sharditerator)

        } else if(operation.shardId ) {
            fetchData();
        }


    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[operation]);


    if(!operation.shardId || !si.ShardIterator ) {
        return null;

    } else {

        return (
            <div className={cn}>
                <ResetShardListButton/> &nbsp;
                {/*<NextShardButton/>*/}
                <br/>
                <table>
                    <tbody>
                    <tr><td>Shard ID:</td><td>
                        <span className='streamArn'>{operation.shardId}</span>
                        </td></tr>
                    <tr><td>Iterator:</td><td>
                        <span className='streamArn'>{si.ShardIterator}</span>
                    </td></tr>
                    </tbody>
                </table>

                <br/><br/>

                <RenderShardRecords si={si.ShardIterator} />

            </div>
        );
    }

};


const RenderShardRecords = (props) => {
    const [{connection},] = useStateValue();
    const [{operation},] = useStateValue();
    const [, dispatch] = useStateValue();
    const [shardRecords, setShardRecords] = useState([]);

    let getRecordsParams = {};

    if(!operation.sharditerator) {
        getRecordsParams['ShardIterator'] = props.si;
    } else {
        getRecordsParams['ShardIterator'] = operation.sharditerator;
    }

    useEffect( () => {

        async function fetchData() {
            const data = await getShardRecords(connection, getRecordsParams);

            setShardRecords(data);
        }

        fetchData();

    },[operation]);

    let srTable = null;

    const eClassName = 'event';

    const sr = shardRecords.Records;

    if(sr && sr.length > 0) {

        srTable = (<table className='dataTable' >
            <tbody>
            <tr><td>Sequence #</td><td>Event</td><td>Keys</td></tr>
            {sr.map((item, index) => {

                const cn = (index%2 > 0 ? 'stripe1' : 'stripe2');

                return (<tr key={index}  className={cn} >
                    <td >{item.dynamodb.SequenceNumber}</td>

                    <td className={eClassName + item.eventName}>{item.eventName}</td>

                    <td >{JSON.stringify(item)}</td>

                </tr>);
            })}

            </tbody>
        </table>);

        return (<div>{srTable}</div>);

    } else {
        // TODO: implement and test the try-next-shard-iterator logic

        const siClickHandler = async () => {
            const op = {action: "streams", target: operation.target, shardId: operation.ShardId, sharditerator: shardRecords.NextShardIterator};

            dispatch({"type": "setOperation", "operation": op});
        };

        return (<div>
            <div className='noShards'>0 records returned.</div>
            <br/>

            {/*Next Shard Iterator<br/>*/}
            {/*<button type="button" className={buttonClass}*/}

                    {/*onClick={ siClickHandler }*/}

                    {/*>Try the Next Shard Iterator</button>*/}
            {/*<br/>*/}
            {/*{shardRecords.NextShardIterator}*/}

        </div>);
    }


};
